import { useState } from "react";
import { ListGroup, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Offcanvas } from "react-bootstrap/esm";
import {
  AiOutlineAppstore,
  AiOutlineBulb,
  AiOutlineCheckCircle,
  AiOutlineCloud,
  AiOutlineProduct,
  AiOutlineSmile,
} from "react-icons/ai";
import { BiCart } from "react-icons/bi";
import { CiDiscount1 } from "react-icons/ci";
import { FaNewspaper, FaPeopleArrows, FaRegFileArchive } from "react-icons/fa";
import { LuBox, LuLayoutDashboard, LuUsersRound } from "react-icons/lu";
import { MdOutlineCategory } from "react-icons/md";
import { PiFlagBannerDuotone } from "react-icons/pi";
import { RiUserSettingsLine } from "react-icons/ri";
import { SiPaperswithcode } from "react-icons/si";
import { useNavigate } from "react-router-dom";

const OffCanvas = ({ show, handleClose }) => {
  const navigate = useNavigate();

  const [activeItem, setActiveItem] = useState(null); // Track clicked item

  const handleClick = (index) => {
    setActiveItem(index); // Update active item on click
  };

  const tooltips = [
    "dashboard",
    "product",
    "Age Group Products",
    "Type Products",
    "Order",
    "Categories",
    "Banner",
    "Promo",
    "Artikel",
    "Career",
    "Customer",
    "User Setting",
  ];

  const paths = [
    "",
    "product",
    "age-group-products",
    "type-products",
    "order",
    "categories",
    "banner",
    "promo",
    "artikel",
    "career",
    "customer",
    "user-setting",
  ];

  // Corresponding icons
  const icons = [
    <LuLayoutDashboard size={32} />, // dashboard
    <LuBox size={32} />, // product
    <FaPeopleArrows size={32} />, // Age Group Products
    <SiPaperswithcode size={32} />, // Type Products
    <BiCart size={32} />, // Categories Cart
    <MdOutlineCategory size={32} />, // Categories Products
    <PiFlagBannerDuotone size={32} />, // Banner Products
    <CiDiscount1 size={32} />,
    <FaNewspaper size={32} />,
    <FaRegFileArchive size={32} />, // Career
    <LuUsersRound size={32} />, // customer
    <RiUserSettingsLine size={32} />, // User Setting
  ];

  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        style={{
          width: "100px",
          border: "none",
          borderRadius: "0",
        }}
      >
        <Offcanvas.Header></Offcanvas.Header>
        <Offcanvas.Body>
          <ListGroup>
            {paths.map((path, index) => (
              <OverlayTrigger
                key={index}
                placement="right"
                overlay={
                  <Tooltip id={`tooltip-${index}`}>{tooltips[index]}</Tooltip>
                }
              >
                <ListGroup.Item
                  action
                  style={{
                    backgroundColor:
                      activeItem === index
                        ? "rgb(2, 126, 33)"
                        : "rgba(108, 117, 125, 0.0)",
                    color: activeItem === index ? "white" : "black",
                    border: "none",
                    borderRadius: "0",
                  }}
                  onClick={() => {
                    handleClick(index);
                    navigate(`/${path}`);
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor =
                      "rgba(2, 126, 33, 0.7)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor =
                      activeItem === index
                        ? "rgb(2, 126, 33)"
                        : "rgba(108, 117, 125, 0.0)")
                  }
                  className="d-flex align-items-center justify-content-center"
                >
                  {icons[index]}
                </ListGroup.Item>
              </OverlayTrigger>
            ))}
          </ListGroup>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};
export default OffCanvas;
